import { render } from "./CalcMain.vue?vue&type=template&id=bc5c8d1c&scoped=true"
import script from "./CalcMain.vue?vue&type=script&lang=js"
export * from "./CalcMain.vue?vue&type=script&lang=js"

import "./CalcMain.vue?vue&type=style&index=0&id=bc5c8d1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc5c8d1c"]])

export default __exports__